export default __webpack_public_path__ + "static/media/lightblue.94dfefbb.jpg";